import { render } from "./addTrainingPlan.vue?vue&type=template&id=672397b2&scoped=true"
import script from "./addTrainingPlan?vue&type=script&lang=js"
export * from "./addTrainingPlan?vue&type=script&lang=js"

import "./addTrainingPlan.vue?vue&type=style&index=0&id=672397b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672397b2"]])

export default __exports__